import { DEFAULT_VALUE_OPTION, TYPE_INSTANCE4 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { useState, useEffect } from "react";

const useInitialUnit = (withSearch = false, url = "/wmsmaster/unit") => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Unit");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await fetchData(TYPE_INSTANCE4, url);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Unit",
              },
            ];
        res.map((item) => {
          return data.push({
            value: parseInt(item.id),
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [withSearch, url]);

  return state;
};

export default useInitialUnit;
